module.exports = __webpack_public_path__ + "static/4-ac2aa265f5506645e534cf5f6e9388f4.jpg";